import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FsMessage, MessageMode } from '@firestitch/message';

import { SigninService } from '@app/core';
import { SessionService } from '@app/core/services';
import { Account } from '@common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard  {
  private _router = inject(Router);
  private _sessionService = inject(SessionService);
  private _message = inject(FsMessage);
  private _signinService = inject(SigninService);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this._signinService.signedIn()) {
      this._message.error('Your session has expired. Please signin again.',
        { mode: MessageMode.Toast });

      return this.createSigninUrlTree();
    }

    const account: Account = this._sessionService.account();

    if (account && account.passwordChange) {
      this._router.navigate(['/passwordchange'], { queryParams: { redirect: state.url } });

      return false;
    }

    return true;
  }

  public createSigninUrlTree(): UrlTree {
    const redirect = window.location.pathname + window.location.search;

    return this._router.createUrlTree(['/signin'],
      { queryParams: { redirect } });
  }

}
